<template lang="pug">
div
  h1.h3.u-mb-sm.u-lineHeight {{$t('mantra')}}

  h6 {{$t('installation')}}
  prism( language="pug" :code="install")
  h6.u-mt-md {{$t('included')}}
  prism( language="js" :code="included")
  a(href="https://github.com/baianat/base.framework", :title="$t('github')" rel="noopener" target="blank").button  #[AppIcon(name="github")] #[span {{$t('github')}}]

</template>

<script>
import CodeSample from '~/components/CodeSample';
import AppIcon from '~/components/AppIcon';
import Prism from 'vue-prism-component';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  layout: 'base',
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }),
  components: {
    CodeSample,
    Prism,
    AppIcon
  },

  data: () => ({
    install: `// Using npm
npm install @baianat/Base.framework --save

// Using yarn
yarn add @baianat/Base.framework
`,
    included: `├── html
├── dist
│   └── css
│       ├── base.css
│       ├── base.min.css
│       ├── base-cssvar.css
│       └── base-cssvar.min.css
├── src
│   └── stylus
│       ├── components
│       ├── core
│       ├── elements
│       ├── grid
│       ├── helper
│       └── util
├── base.styl
└── base-cssvar.styl`
  })
};
</script>

<style lang="stylus" scoped>
.tabs-body
  .button
    margin: 0 unitRes(8, 16) unitRes(8, 16) 0
</style>

<i18n>
{
  "en": {
    "pageTitle":"Getting Started",
    "pageDesc":"Getting Started",
    "mantra":"Getting Started",
    "installation":"Installation",
    "included":"What's included",
    "github":"GitHub Repo"
  },
  "ar": {
    "pageTitle":"ابدأ الآن",
    "pageDesc":"ابدأ الآن",
    "mantra":"ابدأ الآن",
    "installation":"التثبيت",
    "included":"ما يتضمنه!",
    "github":"غيت هاب"
  }
}
</i18n>
